// extracted by mini-css-extract-plugin
export var askAiIcon = "_n3-j";
export var category = "_n3-9";
export var categoryHeader = "_n3-e";
export var container = "_n3-0";
export var group = "_n3-a";
export var groupItems = "_n3-f";
export var groupSeparator = "_n3-k";
export var loading = "_n3-1";
export var noResults = "_n3-3";
export var placeholder = "_n3-2";
export var resultContent = "_n3-5";
export var resultIcon = "_n3-c";
export var resultItem = "_n3-g";
export var resultMeta = "_n3-8";
export var resultSubtitle = "_n3-7";
export var resultSuffix = "_n3-i";
export var resultTitle = "_n3-6";
export var resultsList = "_n3-4";
export var searchGroup = "_n3-d";
export var selected = "_n3-h";
export var subgroup = "_n3-b";